// GENERATED by scripts/sync-brand.mjs from src/lib/brand.tokens.json — DO NOT EDIT.
// Canonical source: SideNerdMarketing/assets/brand/tokens.json (docs: BRAND.md there).
// Regenerate: npm run sync:brand      Verify: npm run check:brand
//
// Notes baked into the tokens (kept out of the data so it stays literal):
// - charts.categorical: validated data-series palette (CVD worst adjacent dE
//   24.2 on white); fixed order, never cycled; 9th+ series folds into otherGray.
//   Deliberately distinct from brand/product accents (accent = UI chrome).
// - color.textDark / color.textMuted / color.success are DEPRECATED v1 aliases
//   of color.text / color.muted / color.ok — do not use in new code.
// - Tints/light accent variants are derived in CSS with color-mix(), never stored.

export const brand = {
  version: "2.0.0",
  color: {
    canvas: "#f6f7f8",
    surface: "#ffffff",
    text: "#16181d",
    muted: "#6b7280",
    faint: "#9aa1ab",
    border: "#e6e7ea",
    borderStrong: "#d8dadf",
    accent: "#34b1e8",
    accentInk: "#0b6795",
    onAccent: "#0d1419",
    ok: "#15803d",
    warn: "#d97706",
    danger: "#b91c1c",
    midnight: "#0d1419",
    navy: "#192933",
    slate: "#2d3748",
    textOnDark: "#e2e8f0",
    textMutedOnDark: "#94a3b8",
    textDark: "#16181d",
    textMuted: "#6b7280",
    success: "#15803d",
  },
  font: {
    sans: "'DM Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
    mono: "'Space Mono', monospace",
    googleFonts: "https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&family=Space+Mono&display=swap",
  },
  radius: {
    sm: "8px",
    md: "12px",
    lg: "16px",
  },
  shadow: {
    sm: "0 1px 2px rgba(16, 24, 40, 0.05)",
    md: "0 1px 3px rgba(16, 24, 40, 0.06), 0 4px 12px rgba(16, 24, 40, 0.06)",
    lg: "0 8px 20px rgba(16, 24, 40, 0.10), 0 20px 48px rgba(16, 24, 40, 0.12)",
  },
  charts: {
    categorical: [
      "#2a78d6",
      "#1baf7a",
      "#eda100",
      "#008300",
      "#4a3aa7",
      "#e34948",
      "#e87ba4",
      "#eb6834",
    ],
    otherGray: "#9aa0a6",
  },
  products: {
    ither: {
      displayName: "Ither",
      registryKey: "ither",
      primary: "#4c70c6",
      primaryInk: "#3d5ba3",
      accent: "#89fdf3",
      accentInk: "#0b6e67",
      onPrimary: "#ffffff",
      onAccent: "#0d1419",
      legacyPrimary: "#5176ca",
    },
    medimatch: {
      displayName: "MediMatch",
      registryKey: "medimatch",
      primary: "#254557",
      primaryInk: "#254557",
      secondary: "#2a93cd",
      secondaryInk: "#1b6d9c",
      accent: "#e67e22",
      accentInk: "#9c4e0e",
      onPrimary: "#ffffff",
      onSecondary: "#0d1419",
      onAccent: "#1f2937",
    },
    linklead: {
      displayName: "Link Lead",
      registryKey: "network",
      primary: "#34b1e8",
      primaryInk: "#0b6795",
      accent: "#34b1e8",
      accentInk: "#0b6795",
      onPrimary: "#0d1419",
      onAccent: "#0d1419",
    },
  },
} as const;

export type ProductKey = keyof typeof brand.products;
